import { OrderItem } from "~/common/types/order";

// What the customer paid per unit for a line, the basis an exchange of it is priced against.
// A line on an exchange order displays the original item's price but cost more if that
// exchange was paid; older payloads carry only the displayed price.
export const getPaidUnitPrice = (orderItem: OrderItem): number =>
  Number(
    orderItem.paidUnitPrice ?? orderItem.displayedPrice ?? orderItem.price ?? 0
  );
